<div class="profile-image" [ngClass]="size">
  @if (size === "demo") {
    <app-icon name="ic_logout" />
  } @else if (imageSrc) {
    <img [src]="imageSrc" alt="" />
  } @else {
    <app-icon name="ic_user" />
  }
</div>
